// extracted by mini-css-extract-plugin
module.exports = {"WordEmphasis":"WordEmphasis_WordEmphasis__1ntK_"};